import { rgba } from "polished";
import { ReactNode } from "react";
import styled from "styled-components";

interface SquadActionBarProps {
  children: ReactNode;
}

const StickyWrapper = styled.div`
  position: sticky;
  bottom: 0;
  padding: ${({ theme }) => `${theme.space[3]} ${theme.space[1]}`};
  background: linear-gradient(
    to top,
    ${({ theme }) => rgba(theme.colors.primary, 0.6)} 0%,
    ${({ theme }) => rgba(theme.colors.primary, 0.25)} 60%,
    transparent 100%
  );
`;

const InnerContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space[2]};
  padding: ${({ theme }) => theme.space[1]};
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 11px;

  @media (max-width: ${({ theme }) => theme.breakpoints[1]}) {
    gap: 6px;
  }
`;

const SquadActionBar = ({ children }: SquadActionBarProps) => {
  return (
    <StickyWrapper>
      <InnerContainer>{children}</InnerContainer>
    </StickyWrapper>
  );
};

export default SquadActionBar;
